
































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";

/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewChapter extends Vue {
  @Prop() show!: any;
  errors: any = [];
  new_chapter: any = {
    name: null,
    id: null,
    contributorName: null,
    imageUrl: null,
  };

  new_exercise: any = {
    name: null,
    id: null,
    description: null,
    shortDescription: null,
    numberQuestionsSelected: null,
  };

  @Emit("NewExercise")
  NewExercise() {
    return this.new_exercise;
  }

  checkRequired() {
    // return true;
    if (
      this.new_exercise.name &&
      this.new_exercise.description &&
      this.new_exercise.shortDescription &&
      this.new_exercise.numberQuestionsSelected
    ) {
      return true;
    }
    this.errors = [];
    if (!this.new_exercise.name) {
      this.errors.push("title required.");
    }
    if (!this.new_exercise.description) {
      this.errors.push("description required.");
    }
    if (!this.new_exercise.shortDescription) {
      this.errors.push("shortDescription  required.");
    }
    if (!this.new_exercise.numberQuestionsSelected) {
      this.errors.push("numberQuestionsSelected required.");
    }
  }
  SaveExercise() {
    this.checkRequired();
    if (this.checkRequired()) {
      this.NewExercise();
    }
  }
  showPopup() {
    this.show = true;
  }
}
